<template>
  <div class="tags-preview">
    {{tags}}
    {{itemtype}}
    {{itemkey}}
    {{ tags_list }}
  </div>
</template>

<script>
//import './../components/generated_svg_icons/'
export default {
  props: {
    tags: { tags:String, itemtype:String, itemkey:String },
  },
  data(){ return {

  }},
  computed: {
    
    tags_list(){
      var tags = this.tags.split(' ')
      return tags
    },

  },
  components: { },
}
</script>



// WEBPACK FOOTER //
// TagsPreview.vue?289aecf6